import { Directive, NgZone, ElementRef, HostListener, Input, OnInit, OnDestroy } from '@angular/core';

import * as _ from 'lodash';
import PopperJS from 'popper.js';

@Directive({
  selector: '[uex-dropdown]',
  host: {
    class: 'uex-dropdown dropdown dropdown-toggle'
  }
})
export class DropdownDirective implements OnInit, OnDestroy {

  @Input('uex-dropdown') private set _setMenu(menu: Element) {
    if (_.isString(menu)) { return; }
    this._menu = menu;
  }

  @Input('placement') private _placement: DropdownPlacement = 'bottom-start';

  constructor(
    private _ngZone: NgZone,
    public elementRef: ElementRef
  ) { }

  private _visible = false;
  private _menu: Element;
  private _popper: PopperJS;

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public ngOnInit(): void {
    this._ngZone.runOutsideAngular(() => {
      document.addEventListener('click', this._clickOutsideEventHandler);
      this.elementRef.nativeElement.addEventListener('click', this._clickEventHandler);
    });
  }

  public ngOnDestroy() {
    if (this._popper) { this._popper.destroy(); }
    if (this._menu) { this._menu.removeAttribute('x-placement'); }

    document.removeEventListener('click', this._clickOutsideEventHandler);
    this.elementRef.nativeElement.removeEventListener('click', this._clickEventHandler);
  }

  public showDropdown() {
    this._setVisible(true);
  }

  public hideDropdown() {
    this._setVisible(false);
  }

  private readonly _clickOutsideEventHandler: (event: MouseEvent) => void = (event: MouseEvent) => this._onClickOutside(event);
  private readonly _clickEventHandler: (event: MouseEvent) => void = (event: MouseEvent) => this._onClick(event);

  private _onClickOutside(event: MouseEvent) {
    const self_child = this.elementRef.nativeElement.contains(event.target);
    const menu_child = !this._menu || (this._menu && this._menu.contains(<Node>event.target));
    if (!self_child && !menu_child) {
      this._setVisible(false);
    }
  }

  private _onClick(event: MouseEvent) {
    this._setVisible(!this._visible);
  }

  private _setVisible(visible: boolean) {
    this._visible = visible;
    this._updateMenuVisibility();
  }

  private _addPopper() {
    this._removePoper();

    if (!this._menu) { return; }

    this._menu.setAttribute('x-placement', this._placement);

    this._popper = new PopperJS(this.elementRef.nativeElement, this._menu, {
      placement: this._placement,
      positionFixed: true
    });
  }

  private _removePoper() {
    if (this._popper) {
      this._popper.destroy();
      this._popper = null;
    }
  }

  private _updateMenuVisibility() {
    if (!this._menu) { return; }

    if (this._visible) {
      this._addPopper();
      this._menu.classList.add('show');
    } else {
      this._menu.classList.remove('show');
      this._removePoper();
    }
  }
}

// Equals to PopperJS.Placement
export type DropdownPlacement = 'auto-start' | 'auto' | 'auto-end' | 'top-start' | 'top' | 'top-end' | 'right-start' | 'right' | 'right-end' | 'bottom-end' | 'bottom' | 'bottom-start' | 'left-end' | 'left' | 'left-start';
